import React from "react";

import { FormHelperText } from "@material-ui/core";

import { Container } from "./styles";

const FormControlError = ({
  className,
  error,
}: {
  className?: any;
  error: string;
}) => (
  <Container className={className}>
    <FormHelperText>{error}</FormHelperText>
  </Container>
);

export default FormControlError;
